import React from "react";
import { Grid, TextField, Button } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
    shopAddress: Yup.string().required("Shop Address is required"),
    shopCity: Yup.string().required("Shop City is required"),
    shopDistrict: Yup.string().required("Shop District is required"),
    shopState: Yup.string().required("Shop State is required"),
    shopPincode: Yup.string().required("Shop Pincode is required"),
    shopLatitude: Yup.string().required("Shop Latitude is required"),
    shopLongitude: Yup.string().required("Shop Longitude is required"),
    companyType: Yup.string().required("Company Type is required"),

});

const AdditionalInfo = ({ initialValues, onSubmit, onBack }) => {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => onSubmit(values)}
        >
            {({ values, errors, touched, handleChange }) => (
                <Form>
                    <Grid container spacing={2}>
                        {/* Shop Details Fields */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Shop Address"
                                name="shopAddress"
                                value={values.shopAddress}
                                onChange={handleChange}
                                error={Boolean(errors.shopAddress && touched.shopAddress)}
                                helperText={touched.shopAddress && errors.shopAddress}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Shop City"
                                name="shopCity"
                                value={values.shopCity}
                                onChange={handleChange}
                                error={Boolean(errors.shopCity && touched.shopCity)}
                                helperText={touched.shopCity && errors.shopCity}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Shop District"
                                name="shopDistrict"
                                value={values.shopDistrict}
                                onChange={handleChange}
                                error={Boolean(errors.shopDistrict && touched.shopDistrict)}
                                helperText={touched.shopDistrict && errors.shopDistrict}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Shop State"
                                name="shopState"
                                value={values.shopState}
                                onChange={handleChange}
                                error={Boolean(errors.shopState && touched.shopState)}
                                helperText={touched.shopState && errors.shopState}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Shop Pincode"
                                name="shopPincode"
                                value={values.shopPincode}
                                onChange={handleChange}
                                error={Boolean(errors.shopPincode && touched.shopPincode)}
                                helperText={touched.shopPincode && errors.shopPincode}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Shop Latitude"
                                name="shopLatitude"
                                value={values.shopLatitude}
                                onChange={handleChange}
                                error={Boolean(errors.shopLatitude && touched.shopLatitude)}
                                helperText={touched.shopLatitude && errors.shopLatitude}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Shop Longitude"
                                name="shopLongitude"
                                value={values.shopLongitude}
                                onChange={handleChange}
                                error={Boolean(errors.shopLongitude && touched.shopLongitude)}
                                helperText={touched.shopLongitude && errors.shopLongitude}
                            />
                        </Grid>
                    </Grid>
                    <Button variant="contained" color="secondary" sx={{ mt: 2, mr: 2 }} onClick={onBack}>
                        Back
                    </Button>
                    <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
                        Submit
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default AdditionalInfo;
